<template>
  <div class="buttons">
    <v-btn-toggle
      group
      tile
      color="indigo lighten-2 accent-3"
      v-model="buttonSelected"
    >
      <v-btn @click="cardView(true)">{{ $tc("commons.card") }}</v-btn>
      <v-btn @click="cardView(false)">{{ $tc("commons.list") }}</v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttonSelected: 0,
    };
  },
  methods: {
    cardView(item) {
      this.$emit("cardView", item);
    },
  },
};
</script>